import { Component, OnInit } from '@angular/core';
import { CountryService } from 'src/app/country.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  country = 'sg';
  constructor(private cs: CountryService) { }

  ngOnInit(): void {
    this.country = this.cs.getCountry();
  }

  switchCountry(c: string) {
    this.cs.setCountry(c);
    window.scrollTo(0, 0);
    window.location.reload();
  }
}
